import { render, staticRenderFns } from "./fourClassify.vue?vue&type=template&id=32eda0f6&scoped=true&"
import script from "./fourClassify.vue?vue&type=script&lang=js&"
export * from "./fourClassify.vue?vue&type=script&lang=js&"
import style0 from "./fourClassify.vue?vue&type=style&index=0&id=32eda0f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eda0f6",
  null
  
)

export default component.exports